import React from 'react';
import Select from "react-select";
import DepartmentTreeSelect from '../../list-department/components/department-tree-select';
import { useHerdsmanForm } from '../hooks/useHerdsmanForm';
import { Controller } from 'react-hook-form';

export default function FormAddEditHerdsman(props) {
    const { 
        triggerSubmit, setTriggerSubmit, onCloseModal, updateItem,
        group, department, zionArea, position, branch,
        onSubmitAddEdit 
    } = props;

    const {
        register, handleSubmit, errors, setValue, control,
        checkActive, setCheckActive,
        buttonSubmitRef,
        onSubmit
    } = useHerdsmanForm(updateItem, onSubmitAddEdit, onCloseModal, triggerSubmit, setTriggerSubmit);

    return (
        <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
            <div className="row">
                <div className="form-group col-md-4">
                    <label>Họ và tên đệm <span className='required'>*</span></label>
                    <input
                        className="form-control"
                        type="text"
                        name="firstName"
                        maxLength={100}
                        defaultValue={updateItem?.firstName}
                        placeholder="Nhập họ và tên đệm"
                        ref={register({ required: true })}
                    />
                    {errors.firstName && errors.firstName.type === "required" && (
                        <span className="error">Trường này là bắt buộc</span>
                    )}
                </div>
                <div className="form-group col-md-4">
                    <label>Tên <span className='required'>*</span></label>
                    <input
                        className="form-control"
                        type="text"
                        name="lastName"
                        maxLength={50}
                        defaultValue={updateItem?.lastName}
                        placeholder="Nhập tên"
                        ref={register({ required: true })}
                    />
                    {errors.lastName && errors.lastName.type === "required" && (
                        <span className="error">Trường này là bắt buộc</span>
                    )}
                </div>
                <div className="form-group col-md-4">
                    <label>Giới tính</label>
                    <select className="form-control" name="gender" ref={register()} defaultValue={updateItem?.gender}>
                        <option value="1">Nam</option>
                        <option value="0">Nữ</option>
                    </select>
                </div>
            </div>
            
            <div className="row">
                <div className="form-group col-md-4">
                    <label>Số điện thoại</label>
                    <input
                        className="form-control"
                        type="text"
                        name="phoneNumber"
                        defaultValue={updateItem?.phoneNumber}
                        placeholder="Số điện thoại"
                        ref={register()}
                    />
                </div>
                <div className="form-group col-md-4">
                    <label>Chức vụ <span className='required'>*</span></label>
                    <Controller
                        name="positionId"
                        control={control}
                        rules={{ required: true }}
                        render={({ onChange, value }) => (
                            <Select
                                isClearable
                                value={position.map(item => ({ label: item.name, value: item.id })).find(x => x.value === value) || null}
                                placeholder="Chức vụ"
                                closeMenuOnSelect={true}
                                onChange={(data) => onChange(data ? data.value : null)}
                                options={position.map(item => { return { label: item.name, value: item.id } })}
                                noOptionsMessage={() => "Không tồn tại"}
                            />
                        )}
                    />
                    {errors.positionId && errors.positionId.type === "required" && (
                        <span className="error">Trường này là bắt buộc</span>
                    )}
                </div>
                <div className="form-group col-md-4">
                    <label>Địa vực <span className='required'>*</span></label>
                    <Controller
                        name="departmentId"
                        control={control}
                        rules={{ required: true }}
                        render={({ onChange, value }) => (
                            <DepartmentTreeSelect
                                isClearable
                                selected={department.find(x => x.value === value) || null}
                                onChange={(data) => onChange(data ? data.value : null)}
                                placeholder="Chọn địa vực"
                                options={department}
                            />
                        )}
                    />
                    {errors.departmentId && errors.departmentId.type === "required" && (
                        <span className="error">Trường này là bắt buộc</span>
                    )}
                </div>
            </div>

            <div className="row">
                <div className="form-group col-md-4">
                    <label>Khu vực <span className='required'>*</span></label>
                    <Controller
                        name="zionAreaId"
                        control={control}
                        rules={{ required: true }}
                        render={({ onChange, value }) => (
                            <Select
                                isClearable
                                value={zionArea.map(item => ({ label: item.name, value: item.id })).find(x => x.value === value) || null}
                                placeholder="Khu vực"
                                closeMenuOnSelect={true}
                                onChange={(data) => onChange(data ? data.value : null)}
                                options={zionArea.map(item => { return { label: item.name, value: item.id } })}
                                noOptionsMessage={() => "Không tồn tại"}
                            />
                        )}
                    />
                    {errors.zionAreaId && errors.zionAreaId.type === "required" && (
                        <span className="error">Trường này là bắt buộc</span>
                    )}
                </div>
                <div className="form-group col-md-4">
                    <label>Chi hội <span className='required'>*</span></label>
                    <Controller
                        name="branchId"
                        control={control}
                        rules={{ required: true }}
                        render={({ onChange, value }) => (
                            <Select
                                isClearable
                                value={(branch || []).map(item => ({ label: item.name, value: item.id })).find(x => x.value === value) || null}
                                placeholder="Chi hội"
                                closeMenuOnSelect={true}
                                onChange={(data) => onChange(data ? data.value : null)}
                                options={(branch || []).map(item => { return { label: item.name, value: item.id } })}
                                noOptionsMessage={() => "Không tồn tại"}
                            />
                        )}
                    />
                    {errors.branchId && errors.branchId.type === "required" && (
                        <span className="error">Trường này là bắt buộc</span>
                    )}
                </div>
                <div className="form-group col-md-4">
                    <div className="row">
                        <div className="form-group col-md-12">
                            <label>Trạng thái hoạt động</label>
                            <div className="switch-button switch-button-yesno ml-5">
                                <input
                                    type="checkbox"
                                    checked={checkActive}
                                    name="isActived"
                                    id="isActived"
                                    ref={register()}
                                    onChange={() => setCheckActive(prev => !prev)}
                                />
                                <span><label htmlFor="isActived"></label></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="form-group col-md-12">
                    <label>Mô tả</label>
                    <input
                        className="form-control"
                        type="text"
                        name="description"
                        defaultValue={updateItem?.description}
                        placeholder="Mô tả"
                        ref={register()}
                    />
                </div>
            </div>

            <button ref={buttonSubmitRef} style={{ display: "none" }} type="submit" className="btn btn-primary">
                Lưu
            </button>
        </form>
    );
}